import { createFileRoute } from "@tanstack/react-router";
import { FaqPage } from "@/pages/legal/FaqPage";
import { localizedHead } from "@/lib/seo";

export const Route = createFileRoute("/en/faq")({
  head: () => {
    const lh = localizedHead({ path: "/faq", locale: "en" });
    return {
      meta: [
        { title: "FAQ — Farveladeland" },
        {
          name: "description",
          content:
            "Frequently asked questions about Farveladeland: orders, shipping, showroom visits and vintage Murano lamps.",
        },
        { property: "og:title", content: "FAQ — Farveladeland" },
        {
          property: "og:description",
          content:
            "Frequently asked questions about orders, shipping and showroom visits.",
        },
        ...lh.meta,
      ],
      links: lh.links,
    };
  },
  component: FaqPage,
});
